module.exports = __webpack_public_path__ + "static/media/ic-sort-az-fill.9255df79.svg";